<template>
  <div class="global-content-box global-content-flex">
    <y-menu-title />
    <div class="global-felx">
      <el-form :model="form" ref="form" label-width="130px">
        <el-form-item label="会员体系名称：" required>
          <el-input
            v-model="form.cardName"
            style="width: 471px"
            maxlength="15"
            show-word-limit
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="店铺选择：" required>
          <div class="chooseShop">
            <div class="shop_text">
              已选择<span>{{ channelSellerManageIdList.length }}</span
              >个店铺
            </div>
            <y-button
              style="margin-left: 12px"
              @click="chooseShop"
              >选择店铺</y-button
            >
          </div>
        </el-form-item>
        <el-form-item label="等级设置：">
          <div>
            最多添加7个会员等级，从低到高依次设置，等级添加后不可删除
          </div>
          <y-table
            :tableInfo="levelSetInfo"
            :showPage="false"
            :tableData="gradeList"
            :autoMaxHeight="false"
            style="margin-top: 15px; width: 450px"
          >
            <template #gradeCode="scope">
              <div class="table-text">Lv.{{ scope.row.gradeCode }}</div>
            </template>
            <template #gradeName="scope">
              <div style="display: flex; align-items: center">
                <div>
                  <el-input
                    v-model="scope.row.gradeName"
                    @blur="verifyName(scope.row)"
                    style="width: 150px"
                    placeholder="请输入"
                    maxlength="64"
                  ></el-input>
                </div>
                <div style="margin-left: 30px">
                  <!-- 最低等级不可删除 -->
                  <y-button
                    v-if="
                      scope.row.gradeCode != 1 && !scope.row.scoresMemberGradeId
                    "
                    class="del_btn"
                    type="blueText"
                    @click="delItem(scope.row)"
                  >
                    删除
                  </y-button>
                </div>
              </div>
            </template>
          </y-table>
          <y-button
            style="margin-top: 12px"
            @click="addNewLevel"
            v-show="gradeList.length != 7"
            >新增等级</y-button
          >
        </el-form-item>
        <el-form-item label="积分设置：" required>
          <y-table
            :tableInfo="integraTableInfo"
            :tableData="integraData"
            :autoMaxHeight="false"
            style="width: 1000px; margin-top: 5px"
          >
            <template #scoresName>
              <el-input
                v-model="form.scoresName"
                maxlength="4"
                show-word-limit
              ></el-input>
            </template>

            <template #scoresIntegerType>
              <!-- <el-input v-model="scope.row.b" :disabled="true"></el-input> -->
              <el-select v-model="form.scoresIntegerType">
                <el-option :value="1" label="向下取整"></el-option>
                <el-option :value="2" label="四舍五入取整"></el-option>
              </el-select>
            </template>

            <template #scoresTimelinessType>
              <div style="line-height: 40px">
                <el-radio v-model="form.scoresTimelinessType" :label="1"
                  >永久有效</el-radio
                >
              </div>
              <div style="line-height: 40px">
                <el-radio v-model="form.scoresTimelinessType" :label="2">
                  <el-input
                    v-model="form.dateCount"
                    @input="inpt"
                    style="width: 100px"
                  ></el-input>
                  <el-select
                    v-model="form.dateUnit"
                    @change="() => (form.dateCount = '')"
                    style="width: 100px; margin: 0px 6px 0px 8px"
                  >
                    <el-option :value="1" label="天"></el-option>
                    <el-option :value="2" label="月"></el-option>
                    <el-option :value="3" label="年"></el-option>
                  </el-select>
                  后过期
                </el-radio>
              </div>
              <div style="line-height: 40px; margin-top: 10px">
                <el-radio v-model="form.scoresTimelinessType" :label="3">
                  <el-select v-model="form.yearAfter" style="width: 100px;margin-right:6px">
                    <el-option :value="0" label="当年"></el-option>
                    <el-option :value="1" label="1年后"></el-option>
                    <el-option :value="2" label="2年后"></el-option>
                    <el-option :value="3" label="3年后"></el-option>
                    <el-option :value="4" label="4年后"></el-option>
                    <el-option :value="5" label="5年后"></el-option>
                  </el-select>
                  年后的12月31日失效
                </el-radio>
              </div>
              <div style="line-height: 40px; margin-top: 5px">
                <el-radio v-model="form.scoresTimelinessType" :label="4"
                  >从会员的入会时间起，每年该日期使该会员
                  <el-select v-model="form.yearBefore" style="width: 100px;margin:0px 6px">
                    <el-option :value="0" label="所有"></el-option>
                    <el-option :value="1" label="半年之前"></el-option>
                    <el-option :value="2" label="1年之前"></el-option>
                    <el-option :value="3" label="2年之前"></el-option>
                    <el-option :value="4" label="3年之前"></el-option>
                  </el-select>
                  的积分过期
                </el-radio>
              </div>
            </template>
          </y-table>
        </el-form-item>
        <el-form-item label="入会设置：">
          <div>
            会员首次入会后赠送<el-input
              v-model="form.registerPoint"
              placeholder=""
              style="width: 100px; margin: 0 8px"
              v-numOnly9
            ></el-input>积分
          </div>

          <div>
            （注：针对该会员体系，首次入会后赠送积分。设置为0或空则不送积分）
          </div>
        </el-form-item>
        <el-form-item label="退会设置：">
          <el-checkbox-group v-model="logoutMemberSet">
            <el-checkbox :label="1">积分清零</el-checkbox>
            <el-checkbox :label="2">成长值清零</el-checkbox>
            <el-checkbox :label="3">累计交易金额清零</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            type="textarea"
            class="Mytextarea"
            style="width: 543px"
            resize="none"
            placeholder="请在这里输入备注"
            v-model="form.remark"
            :maxlength="99"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="global-bottom-btn">
      <y-button v-if="loading" :loading="loading" type="blue">保存</y-button>
      <y-button v-else :loading="loading" type="blue" @click="save">
        保存
      </y-button>
    </div>
    <!-- 选择店铺弹窗 -->
    <chooseShop
      v-if="chooseShopShow"
      :visible="chooseShopShow"
      :selected.sync="channelSellerManageIdList"
      @close="chooseShopShow = false"
    ></chooseShop>
  </div>
</template>

<script>
import {
  saveScoresCard,
  getDetailById,
} from "@/api/integralCenter/newMemberSystem";
import chooseShop from "@/components/chooseShop.vue";
export default {
  components: {
    chooseShop,
  },
  data() {
    return {
      MemberSystemInfo: {},
      // 表单
      form: {
        scoresIntegerType: 1, //取整方式
        cardName: "", // 会员体系名称
        scoresName: "", // 积分名称
        scoresTimelinessType: 1, //积分时效性类型
        dateUnit: 1, // 时间单位
        dateCount: "", // 时间数值
        yearAfter: 0, // 固定时效时间枚举
        yearBefore: 1, // 年前枚举
        remark: "", // 备注
        registerPoint: "",
      },
      logoutMemberSet: [], //退会设置
      gradeList: [
        // 会员等级设置
        { gradeCode: 1, gradeName: "店铺客户" },
      ],
      channelSellerManageIdList: [], // 店铺id列表
      integraData: [{ a: "", b: "向下取整" }],
      chooseShopShow: false,
      loading: false,

      levelSetInfo: [
        {
          label: "等级编号",
          prop: "gradeCode",
          slot: "gradeCode",
          width: "150",
        },
        {
          label: "等级名称",
          prop: "gradeName",
          slot: "gradeName",
        },
      ],
      integraTableInfo: [
        {
          label: "积分名称",
          prop: "scoresName",
          slot: "scoresName",
          width: "150",
        },
        {
          label: "取整方式",
          prop: "scoresIntegerType",
          slot: "scoresIntegerType",
          width: "150",
        },
        {
          label: "积分时效性",
          prop: "scoresTimelinessType",
          slot: "scoresTimelinessType",
        },
      ],
    };
  },
  created() {
    this.buriedPoint(1, "忠诚度管理", "忠诚度管理", "会员体系设置");
  },
  mounted() {
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
    this.getDetailById();
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex == 1) {
        return "success-row";
      }
      return "";
    },
    // 获取会员体系详情
    getDetailById() {
      getDetailById({
        cardId: this.$store.state.MemberSystemInfo.scoresCardId,
      }).then((res) => {
        this.form.cardName = res.data.cardName;
        this.channelSellerManageIdList = res.data.channelSellerManageIdList;
        if (res.data.gradeList.length == 0) {
          this.gradeList = [{ gradeCode: 1, gradeName: "店铺客户" }];
        } else {
          this.gradeList = res.data.gradeList;
        }
        this.form.scoresTimelinessType = res.data.scoresTimelinessType;
        this.form.scoresName = res.data.scoresName || "积分";
        this.form.dateUnit = res.data.dateUnit || 1;
        this.form.dateCount = res.data.dateCount || "";
        this.form.yearBefore =
          res.data.yearBefore != null ? res.data.yearBefore : 1;
        this.form.yearAfter = res.data.yearAfter || 0;
        this.form.scoresIntegerType = res.data.scoresIntegerType || 1;
        this.form.registerPoint = res.data.registerPoint || "";
        this.form.remark = res.data.remark || "";
        this.logoutMemberSet =
          res.data.logoutMemberSet.split(",").map(Number) || [];
        console.log("111", res.data.logoutMemberSet.split(",").map(Number));
      });
    },
    // 积分时效性输入框根据日期单位限制输入
    inpt(val) {
      let type = this.form.dateUnit;
      // 限制输入正整数 开头不为0
      let num = val.replace(/\D|^0/g, "");
      this.form.dateCount = num;
      if (type == 1 && num > 999) {
        this.form.dateCount = 999;
        this.$message.warning("不可大于999天");
      } else if (type == 2 && num > 60) {
        this.form.dateCount = 60;
        this.$message.warning("不可大于60个月");
      } else if (type == 3 && num > 5) {
        this.$message.warning("不可大于5年");
        this.form.dateCount = 5;
      }
    },
    // 验证等级名称是否相同
    verifyName(val) {
      // 未输入时不触发校验
      if (val.gradeName == "") return;
      // 不和当前等级比对
      this.gradeList
        .filter((item) => item != val)
        .forEach((item) => {
          // 校验时去除空格
          if (
            item.gradeName.replace(/\s*/g, "") ==
            val.gradeName.replace(/\s*/g, "")
          ) {
            val.gradeName = "";
            this.$message.warning("等级名称不可重复");
          }
        });
    },
    // 新增等级
    addNewLevel() {
      this.gradeList.push({ gradeCode: "", gradeName: "" });
      // 重新排列等级编号
      this.gradeList.forEach((item, index) => {
        item.gradeCode = index + 1;
      });
    },
    // 删除等级
    delItem(row) {
      console.log("删除当前项===》", row);
      // 删除当前项
      this.gradeList = this.gradeList.filter((item) => item != row);
      // 重新排列等级编号
      this.gradeList.forEach((item, index) => {
        item.gradeCode = index + 1;
      });
    },
    // 等级编号索引
    indexMethod(val) {
      return "Lv." + (val + 1);
    },
    // 打开选择店铺弹窗
    chooseShop() {
      this.chooseShopShow = true;
    },
    // 保存
    save() {
      console.log(this.gradeList);
      let obj = {
        ...this.form,
        gradeList: this.gradeList,
        channelSellerManageIdList: this.channelSellerManageIdList,
        scoresCardId: this.MemberSystemInfo.scoresCardId,
        logoutMemberSet: this.logoutMemberSet.toString(),
      };
      if (!obj.cardName) return this.$message.warning("请输入会员体系名称");
      if (!obj.channelSellerManageIdList.length)
        return this.$message.warning("请选择店铺");
      let flag = false;
      obj.gradeList.forEach((item) => {
        if (!item.gradeName) flag = true;
      });
      if (flag) return this.$message.warning("请将等级名称填写完整");
      if (!obj.scoresName) return this.$message.warning("请输入积分名称");
      if (obj.scoresTimelinessType == 2 && !obj.dateCount)
        return this.$message.warning("请将积分时效性填写完整");
      this.loading = true;
      saveScoresCard(obj)
        .then((res) => {
          // if (res.code == 200) {
          this.$message.success("保存成功");
          this.getDetailById();
          this.loading = false;
          // }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.table-text {
  color: $text-color;
}

.del_btn {
  cursor: pointer;

  img {
    width: 20px;
    height: 20px;
    position: relative;
    top: 5px;
  }
}

.chooseShop {
  display: flex;

  .shop_text {
    span {
      color: #FE7622;
      margin: 0 5px;
    }
  }

  .choose_btn {
    border: 1px solid $theme-color;
    color: $theme-color;
    cursor: pointer;
    margin-left: 12px;

    &:hover {
      background-color: $theme-color;
      color: #ffffff;
    }
  }
}
</style>
<style lang="scss">
// 修改富文本框
.Mytextarea {
  .el-textarea__inner {
    min-height: 120px !important;
    resize: none;

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
    }

    &::-webkit-scrollbar-thumb {
      min-height: 20px;
      border-radius: 10px;
      background-clip: content-box;
      box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.2) inset;
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }
  }
}
</style>
